import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Girls from './pages/Girls';
import GirlProfile from './pages/GirlProfile';
import Contact from './pages/Contact';
import { useEffect, useState } from 'react';
import { getAllData, getGlobalStyling } from './apis/firebase';
import LoadingScreen from './components/LoadingScreen';

function ClientApp() {
    const [ladies, setLadies] = useState([]);
    const [avails, setAvails] = useState([]);
    const [services, setServices] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [globalFont, setGlobalFont] = useState('');
    const [fontLoaded, setFontLoaded] = useState(false);

    useEffect(() => {
        const fetchStyling = async () => {
            const styling = await getGlobalStyling();
            if (styling?.font) {
                // Load font dynamically
                const fontFamily = styling.font.replace(' ', '+');
                const link = document.createElement('link');
                link.href = `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@400;500;600;700&display=swap`;
                link.rel = 'stylesheet';

                link.onload = () => {
                    setGlobalFont(styling.font);
                    setFontLoaded(true);
                };

                document.head.appendChild(link);
            }
        };
        fetchStyling();
        getAllData(setAvails, setLadies, setServices, setLoaded)
    }, []);

    if (loaded == false) {
        return <LoadingScreen />
    }

    return (
        <div style={{
            fontFamily: fontLoaded ? `'${globalFont}', sans-serif` : 'sans-serif'
        }} className="min-h-screen flex flex-col bg-black">
            <Navbar />
            <div className="flex-grow pt-16">
                <Routes>
                    <Route path="/" element={<Home ladies={ladies} avails={avails} />} />
                    <Route path="/services" element={<Services services={services} />} />
                    <Route path="/ladies" element={<Girls ladies={ladies} />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/ladies/:name" element={<GirlProfile ladies={ladies} />} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
}

export default ClientApp;